// loanPaymentApiSlice.js - Updated version
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loanPaymentApiSlice = createApi({
  reducerPath: "loanPaymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl:  "https://moneylend.dockyardsoftware.com/",
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["LoanPayment"],
  endpoints: (builder) => ({
    // Get all loan payments
    getAllLoanPayments: builder.query({
      query: () => "Payment/GetAllPayments",
      transformResponse: (response) => {
        return response?.ResultSet || [];
      },
      providesTags: ["LoanPayment"],
    }),

    // Get payments by borrower
    getPaymentsByBorrower: builder.query({
      query: (borrowerId) => `Payment/GetPaymentsByBorrower?borrowerId=${borrowerId}`,
      transformResponse: (response) => response?.ResultSet || [],
      providesTags: ["LoanPayment"],
    }),


     // Get payments by loan ID
    getPaymentsByLoan: builder.query({
      query: (loanId) => `Payment/GetPaymentsByLoan?loanId=${loanId}`,
      transformResponse: (response) => response?.ResultSet || [],
      providesTags: ["PaymentHistory"],
    }),


    // Make a payment
    // makePayment: builder.mutation({
    //   query: (paymentData) => ({
    //     url: "Payment/MakePayment",
    //     method: "POST",
    //     body: paymentData,
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   }),
    //   transformResponse: (response) => {
    //     // Store payment in localStorage for history (optional)
    //     const existingPayments = JSON.parse(localStorage.getItem('paymentList') || '[]');
    //     existingPayments.push({
    //       ...response,
    //       timestamp: new Date().toISOString()
    //     });
    //     localStorage.setItem('paymentList', JSON.stringify(existingPayments));
        
    //     return response;
    //   },
    //   invalidatesTags: ["LoanPayment"],
    // }),


    // Update the makePayment mutation in loanPaymentApiSlice.js
// Make a payment
// loanPaymentApiSlice.js - Keep existing but ensure the transformResponse doesn't interfere
makePayment: builder.mutation({
  query: (payload) => ({
    url: "Payment/MakePayment",
    method: "POST",
    body: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  transformResponse: (response, meta, arg) => {
    // Note: We're now handling localStorage update in MakePayment.js component
    // This transformResponse should just return the API response
    return response;
  },
  invalidatesTags: ["LoanPayment"],
}),

    // Get schedule summary by payment ID
    getScheduleSummaryByPaymentId: builder.query({
      query: (paymentId) => `Payment/GetScheduleSummaryByPaymentId?paymentId=${paymentId}`,
      transformResponse: (response) => response?.ResultSet || [],
      providesTags: ["LoanPayment"],
    }),

    // Get allocation history
    getAllocationHistory: builder.query({
      query: ({ paymentId, scheduleId }) => 
        `Payment/GetAllocationHistory?paymentId=${paymentId}&scheduleId=${scheduleId}`,
      transformResponse: (response) => response?.ResultSet || [],
      providesTags: ["LoanPayment"],
    }),
  }),
});

export const { 
  useGetAllLoanPaymentsQuery, 
  useGetPaymentsByBorrowerQuery, 
  useGetPaymentsByLoanQuery,
  useMakePaymentMutation,
  useGetScheduleSummaryByPaymentIdQuery,
  useGetAllocationHistoryQuery 
} = loanPaymentApiSlice;